export const SET_VALIDATION = (state, person) => {
    state.personPreviewData = person;
    
}

export const NEW_ERROR = (state, person) => {
    state.errorsBack = person
}

export const LOADING = (state, loading) => {
    state.loading = loading
}

export const SET_ADDRESS1_TEMP = (state, address1_temp) => {
    state.address1_temp = address1_temp
}

export const SET_PREF_CD = (state, pref_cd) => {
    state.pref_cd = pref_cd
}

export const SET_UID = (state, uid) => {
    state.uid = uid
}

export const SET_SUCCESS_MESSAGE = (state, msg) => {
    state.successMsg = msg
}

export const ERROR_PAGE_SHOW = (state, errorPageShown) => {
    state.errorPageShow = errorPageShown
}

export const EMPTY_ERROR = (state, emptyerror) => {
    state.errorsBack = emptyerror
}

export const PREVIEW_DATA_EMPTY = (state, previewDataEmpty) => {
    state.personPreviewData = previewDataEmpty
}



